import { Api } from "../api/Api";
import * as EnvConstants from "../Constants/EnvConstants";
import {useErrorWebhook} from "./useErrorWebhook";

export const useClaimReg = () => {
  const { ErrorWebhookTrigger } = useErrorWebhook();
  const updateClaimReg = async (
    uuid,
    page_name,
    claim_msg,
    source = "live",
  ) => {
    const response = await Api.post("api/v1/claim_reg_click", {
        uuid,
        page_name,
        claim_msg,
        source
        
    }).catch(function (error) {
      const erroMessage = {
        serviceName : 'CLAIM REG CLICK',
        errorReason:error.message,
        errorCode:error.code,
        uuid:uuid
      }
      ErrorWebhookTrigger(erroMessage);
    });
    return response;
  };

  const clickPreviewVisit = async (
    uuid,
    page_name,
    claim_msg,
    source
  ) => {
    const response = await Api.post("api/v1/preview_visit_click", {
        uuid,
        page_name,
        claim_msg,
        source
        
    }).catch(function (error) {
      const erroMessage = {
        serviceName : 'PREVIEW VISIT CLICK',
        errorReason:error.message,
        errorCode:error.code,
        uuid:uuid
      }
      ErrorWebhookTrigger(erroMessage);
    });
    return response;
  };
  const clickPreviewVisitFlp = async (
    uuid,
    page_name,
    claim_msg,
    source
  ) => {
    const response = await Api.post("api/v1/preview_visit_click_flp", {
        uuid,
        page_name,
        claim_msg,
        source,
        cakepost : 0,
    }).catch(function (error) {
      const erroMessage = {
        serviceName : 'PREVIEW VISIT CLICK FLP',
        errorReason:error.message,
        errorCode:error.code,
        uuid:uuid
      }
      ErrorWebhookTrigger(erroMessage);
    });
    return response;
  };
  const signatureConfirmFlp = async (
    uuid,
    page_name,
    message,
    source
  ) => {
    const response = await Api.post("api/v1/signature-confirm", {
        uuid,
        page_name,
        message,
        source
    }).catch(function (error) {
      const erroMessage = {
        serviceName : 'SIGNATURE CONFIRM CLICK',
        errorReason:error.message,
        errorCode:error.code,
        uuid:uuid
      }
      ErrorWebhookTrigger(erroMessage);
    });
    return response;
  };

  const signatureConfirmVaqV2Flp = async (
    uuid,
    page_name,
    message,
    source
  ) => {
    const response = await Api.post("api/v1/signature-confirm-vaq", {
        uuid,
        page_name,
        message,
        source
    });
    return response;
  };

  const clickMeritPageVisit = async (
    uuid,
    page_name,
    claim_msg,
    source
  ) => {
    const response = await Api.post("api/v1/merit_page_click", {
        uuid,
        page_name,
        claim_msg,
        source
    }).catch(function (error) {
      const erroMessage = {
        serviceName : 'MERIT PAGE VISIT CLICK',
        errorReason:error.message,
        errorCode:error.code,
        uuid:uuid
      }
      ErrorWebhookTrigger(erroMessage);
    });
    return response;
  };
   const clickReEngage = async (
    uuid,
    re_engaged_id,
    page_name,
    click_type,
    click_label,
    source = "live",
  ) => {
    const response = await Api.post("api/v1/re_engaged_claim_reg_click", {
        uuid,
        re_engaged_id,
        page_name,
        click_type,
        click_label,
        source
        
    }).catch(function (error) {
      const erroMessage = {
        serviceName : 'CLAIM REG CLICK',
        errorReason:error.message,
        errorCode:error.code,
        uuid:uuid
      }
      ErrorWebhookTrigger(erroMessage);
    });
    return response;
  };

  const nextButtonClick = async (
    uuid,
    page_name,
    click_label,
    source = "live",
  ) => {
    const response = await Api.post("api/v1/next_button_click", {
        uuid,
        page_name,
        click_label,
        source
        
    }).catch(function (error) {
      const errorMessage = {
        serviceName : 'NEXT BUTTON CLICK',
        errorReason:error.message,
        errorCode:error.code,
        uuid:uuid
      }
      ErrorWebhookTrigger(errorMessage);
    });
    return response;
  };

  return { updateClaimReg,clickPreviewVisit,clickPreviewVisitFlp,signatureConfirmFlp,clickMeritPageVisit,clickReEngage,nextButtonClick };
};
